import React from "react";
import {cx} from "../../../lib/ClassSet";
import StatusTag from "../../../components/StatusTag";
import {statusColor, statusLabel} from "../statusDisplay";
import {AdviceTag} from "../../shared/AdviceSent";
import {shortenDate} from "../../stockTransfers/statusDisplay";

const PurchaseOrderItem = (props) => {
  const {data} = props;
  const status = data.get("status");

  const classes = cx({
    "item": true,
    "purchase-order-list-item": true,
    "u-selected": props.selected,
    "u-cancelled": status === "cancelled",
    "u-completed": status === "received",
  });

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field">{data.get("poNumber") || data.get("id")}</td>
      <td className="field">{data.get("partnerName")}</td>
      <td className="field f-warehouse">{data.get("destinationWarehouseId")}</td>
      <td className="field f-date">{shortenDate(data.get("orderDate"))}</td>
      <td className="field f-date">{shortenDate(data.get("expectedDeliveryDate"))}</td>
      <td className="field f-quantity">{data.get("totalQuantity")}</td>
      <td className="field f-status">
        <StatusTag color={statusColor(status)} text={statusLabel(status)} noMargin />
        {" "}
        <AdviceTag sent={data.get("adviceSent")} sentAt={data.get("adviceSentAt")} open={status === "draft" || status === "ordered"} />
      </td>
    </tr>
  )
}

export default PurchaseOrderItem;
